import { useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
import { updateUserPropertiesMutation } from '../api/userObject.queries';
import { HS_AWAY_STATUS_TIMER } from '../constants';
import { getParsedJsonPropertyValue } from '../records/CrmObject';
import { getCrmObjectByUserIdQuery, useUserPropertyValue } from './useUserPropertyValue';
import Raven from 'raven-js';
export const useAwayStatusTimer = (userId, options) => {
  const {
    value: awayStatusTimer,
    loading: isLoadingTimer
  } = useUserPropertyValue(userId, HS_AWAY_STATUS_TIMER, getParsedJsonPropertyValue);
  const [updateProperty, {
    loading: isUpdating
  }] = useMutation(updateUserPropertiesMutation, {
    refetchQueries: [getCrmObjectByUserIdQuery],
    awaitRefetchQueries: true
  });
  const updateAwayStatusTimer = useCallback(timerData => {
    if (!timerData.durationMins || timerData.durationMins <= 0) {
      throw new Error('Invalid duration');
    }
    if (!timerData.timerStartedAt) {
      throw new Error('Invalid start time');
    }
    return updateProperty({
      variables: {
        userId,
        isViewingSelf: !!options.isViewingSelf,
        userProperties: {
          [HS_AWAY_STATUS_TIMER]: JSON.stringify(timerData)
        }
      }
    }).catch(error => {
      Raven.captureException(error);
      throw error;
    });
  }, [options.isViewingSelf, updateProperty, userId]);
  return {
    awayStatusTimer,
    isLoadingTimer,
    isUpdating,
    updateAwayStatusTimer
  };
};